import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { BranchHierarchyLogsService } from './branchhierarchy-logs.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'branchhierarchy-logshistorypopup',
    standalone: true,
    imports: [
        MatDialogModule,
        MatTableModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        DatePipe
    ],
    templateUrl: './branchhierarchy-logs.component.html',
    styleUrls: ['../../../../style/custom-mat-dialog.component.less', './branchhierarchy-logs.component.less']
})
export class BranchHierarchyLogsHistoryPopupComponent implements OnInit {

    columnsToDisplay: string[] = ['Action', 'MgmtBranch', 'Region', 'District', 'Branch', 'Number', 'Key', 'TimeZone', 'ChangedBy', 'ChangedAtUtc'];
    public dataSource = new MatTableDataSource<any>();
    public title: string = 'Branch Hierarchy Audit';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { element: BranchHierarchyView },
        public dialogRef: MatDialogRef<BranchHierarchyLogsHistoryPopupComponent>,
        private readonly branchHierarchyLogsService: BranchHierarchyLogsService
    ) { }

    ngOnInit(): void {
        this.branchHierarchyLogsService.getBranchHierarchyAudit(this.data.element.BranchHierarchyId).subscribe(result => {
            this.dataSource.data = Array.isArray(result) ? result : [result];
        });
    }

    applyFilter($event: any) {
        this.dataSource.filter = $event.target.value.trim().toLowerCase();
    }
}

